import { Modal, Form, Button } from 'react-bootstrap';
import Flatpickr from 'react-flatpickr';

const LogTimeModal = ({
    show,
    onHide,
    logDate,
    setLogDate,
    logTime,
    setLogTime,
    logDescription,
    setLogDescription,
    onSubmit
}) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title className='display-1'>Log Time</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className='mb-3'>
                        <Form.Label>Date <span className='text-danger'>*</span></Form.Label>
                        <Flatpickr
                            value={logDate}
                            onChange={([date]) => setLogDate(date)}
                            className="form-control"
                            options={{
                                dateFormat: 'd M Y',
                                maxDate: 'today',
                                allowInput: true,
                                disableMobile: true,
                                enableTime: false
                            }}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Time Spent <span className='text-danger'>*</span></Form.Label>
                        <Form.Control
                            type="text"
                            value={logTime}
                            onChange={(e) => setLogTime(e.target.value)}
                            placeholder="e.g., 2h 30m"
                        />
                        <Form.Text className="p-tag fs-12">
                            Enter time in hours and minutes (e.g., 2h 30m, 45m, 1.5h)
                        </Form.Text>
                        <div className='d-flex justify-content-start gap-2 mt-2'>
                            <Button variant="link" className='text-decoration-none' size="sm" onClick={() => setLogTime('2h')}>2h</Button>
                            <Button variant="link" className='text-decoration-none' size="sm" onClick={() => setLogTime('1h')}>1h</Button>
                            <Button variant="link" className='text-decoration-none' size="sm" onClick={() => setLogTime('45m')}>45m</Button>
                            <Button variant="link" className='text-decoration-none' size="sm" onClick={() => setLogTime('30m')}>30m</Button>
                            <Button variant="link" className='text-decoration-none' size="sm" onClick={() => setLogTime('15m')}>15m</Button>
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={logDescription}
                            onChange={(e) => setLogDescription(e.target.value)}
                            placeholder="What did you work on?"
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-between'>
                <Button variant="link" className='text-danger text-decoration-none' onClick={onHide}>
                    Cancel
                </Button>
                <div>
                    <Button
                        variant="primary"
                        onClick={onHide}
                        className='me-3'
                    >
                        Save & Log Another
                    </Button>
                    <Button
                        variant="primary"
                        onClick={onHide}
                    >
                        Log Time
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default LogTimeModal;
